import React from 'react';
import { FaRegCopyright } from "react-icons/fa6";

const CopyRights = () => {
    return (
        <>
            <div
                style={{
                    background: "#020c27ff",
                    color: "#fff",
                    width: "100%"
                }}
            >
                <div className="container-lg">
                    <div className="row p-4 m-0">
                        <div className="col-md-12 text-center" >
                            <FaRegCopyright /><span className='ps-2'>2026 Oriental Business Solutions Inc. All rights reserved. | Powered by Magizhini Technology Services Inc.</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CopyRights;